<template>
	<div class="download-error-modal">
		<ErrorState :color="'white'">
			<p>One or more of your files failed to download due to a system error:</p>
			<ul>
				<li v-for="(downloadItem, index) in failedDownloadsArr" :key="index">
					{{ downloadItem }}
				</li>
			</ul>
		</ErrorState>
	</div>
</template>

<script>
import ErrorState from "../../error-state/ErrorState";

export default {
	name: "DownloadErrorModal",
	components: { ErrorState },
	props: {
		failedDownloadsArr: {
			type: Array
		}
	}
};
</script>

<style lang="scss">
.download-error-modal p {
	font-size: 32px;
	margin-bottom: 2em;
}
.download-error-modal ul {
	font-size: 24px;
	text-align: left;
}
</style>
